import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

import { CardNumberInputStyled, Input, Error } from "./CardNumberInput.styled";

function CardNumberInput({
    setCardNumber,
    hasError,
    hasBalance,
    errorMessage
}) {
    const { register, getValues } = useFormContext();

    const inputFields = [
        { id: 0, maxLength: 4, defaultValue: "6064", isDisabled: true },
        { id: 1, maxLength: 4, defaultValue: "", isDisabled: false },
        { id: 2, maxLength: 4, defaultValue: "", isDisabled: false },
        { id: 3, maxLength: 4, defaultValue: "", isDisabled: false },
        { id: 4, maxLength: 3, defaultValue: "", isDisabled: false }
    ];

    function handleInput({ target }, maxLength) {
        if (
            target.value.length >= maxLength &&
            target.nextSibling &&
            !target.nextSibling.disabled
        ) {
            // eslint-disable-next-line no-param-reassign
            target.value = target.value.slice(0, maxLength);

            if (target.nextSibling.value.length === 0) {
                target.nextSibling.focus();
            }
        } else {
            // eslint-disable-next-line no-param-reassign
            target.value = target.value.slice(0, maxLength);
        }

        if (target.value.length === 0 && target.previousSibling) {
            target.previousSibling.focus();
        }

        if (setCardNumber) {
            const cardNumberObj = getValues();
            const cardNumber =
                cardNumberObj["code[0]"] +
                cardNumberObj["code[1]"] +
                cardNumberObj["code[2]"] +
                cardNumberObj["code[3]"] +
                cardNumberObj["code[4]"];
            setCardNumber(cardNumber);
        }
    }

    function renderPlaceholder(length) {
        return Array(length).fill("-").join("");
    }

    return (
        <CardNumberInputStyled hasError={hasError} hasBalance={hasBalance}>
            {inputFields.map((field, index) => (
                <Input
                    key={`code[${field.id}]`}
                    name={`code[${index}]`}
                    aria-label={`Code invoerveld ${index + 1}`}
                    type="number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder={renderPlaceholder(field.maxLength)}
                    defaultValue={field.defaultValue}
                    disabled={field.isDisabled}
                    ref={register({
                        required: "Uw code is hier verplicht",
                        pattern: {
                            value: /^[0-9]*$/,
                            message: "Dit veld mag alleen cijfers bevatten"
                        },
                        minLength: {
                            value: field.maxLength,
                            message: `Veld ${field.id} moet ${field.maxLength} cijfers bevatten `
                        }
                    })}
                    maxLength={field.maxLength}
                    min="0"
                    max={field.maxLength === 3 ? "999" : "9999"}
                    onChange={event => handleInput(event, field.maxLength)}
                    hasError={hasError}
                    hasBalance={hasBalance}
                />
            ))}
            {errorMessage && <Error>{errorMessage}</Error>}
        </CardNumberInputStyled>
    );
}

CardNumberInput.propTypes = {
    errorMessage: PropTypes.string,
    setCardNumber: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.oneOf([null])
    ]),
    hasError: PropTypes.bool,
    hasBalance: PropTypes.bool
};

CardNumberInput.defaultProps = {
    errorMessage: undefined,
    setCardNumber: null,
    hasError: false,
    hasBalance: false
};

export default CardNumberInput;
